var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h67v67H0z",
    "data-name": "Rectangle 1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.612 43a2.38 2.38 0 0 1-1.689-.7L23.7 27.077a2.39 2.39 0 0 1 0-3.377 2.39 2.39 0 0 1 3.377 0L42.3 38.923A2.388 2.388 0 0 1 40.612 43",
    "data-name": "Line 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 40.612a2.38 2.38 0 0 1 .7-1.689L38.923 23.7a2.388 2.388 0 0 1 3.377 3.377L27.077 42.3A2.388 2.388 0 0 1 23 40.612",
    "data-name": "Line 4"
  })))));
};
export default SvgX;